export const getViewTabTitles = ({ current, expired, removed }) => {   
    return [
        `(${current}) Vigentes`,
        `(${expired}) Caducados`,
        `(${removed}) Eliminados`,
    ];
}